// extracted by mini-css-extract-plugin
module.exports = {"status__edit":"ProfileStatus_status__edit__2KEwF","statuse__text":"ProfileStatus_statuse__text__3u_ID"};